import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

class RangeSlider extends Component {
  constructor (elem, theme, options, ctx) {
    options = {...{
      connect: true,
      eventsOnUpdate: []
    }, ...options}
    super(elem, theme, options, ctx)
    
    this._rangeElem = this._elem.querySelector('[data-range-slider-elem]')

    this._minInput = this._elem.querySelector('[data-min-elem]')
    this._maxInput = this._elem.querySelector('[data-max-elem]')

    this._min = this._elem.querySelectorAll('[data-min]')
    this._max = this._elem.querySelectorAll('[data-max]')

    this._initialMax = Number(this._maxInput.value)
    this._initialMin = Number(this._minInput.value)
  }
 
  async mount () {
    const noUiSlider = await import('nouislider')
    noUiSlider.create(this._rangeElem, this._options)

    this._rangeElem.noUiSlider.on('update', e => {
      if (this._options.callComponent) {
        let comp = this._theme.getComponent(this._options.callComponent).component
        comp[this._options.callMethod](Number(this._rangeElem.noUiSlider.get()))        
      }

      for (let elem of this._min) {
        elem.innerHTML = Helpers.formatMoney(Math.floor(this._rangeElem.noUiSlider.get()[0] * 100.00), this._ctx.getState(), true)
      }

      for (let elem of this._max) {
        elem.innerHTML = Helpers.formatMoney(Math.floor(this._rangeElem.noUiSlider.get()[1] * 100.00), this._ctx.getState(), true)
      }

    })

    this._rangeElem.noUiSlider.on('slide', e => {
      let newMin = Math.floor(this._rangeElem.noUiSlider.get()[0])
      let newMax = Math.floor(this._rangeElem.noUiSlider.get()[1])

      if (newMin !== Number(this._minInput.value)) {
        this._minInput.value = Math.floor(this._rangeElem.noUiSlider.get()[0])
        this._minInput.dispatchEvent(new Event('change'))
      }

      if (newMax !== Number(this._maxInput.value)) {
        this._maxInput.value = Math.floor(this._rangeElem.noUiSlider.get()[1])
        this._maxInput.dispatchEvent(new Event('change'))
      }

    })

    this._rangeElem.noUiSlider.on('set', e => {

      let newMin = Math.floor(this._rangeElem.noUiSlider.get()[0])
      let newMax = Math.floor(this._rangeElem.noUiSlider.get()[1])

      if (newMin !== this._initialMin) {
        this._minInput.value = Math.floor(this._rangeElem.noUiSlider.get()[0])
        this._minInput.dispatchEvent(new Event('change'))
        this._minInput.dispatchEvent(new CustomEvent('update-filter'))
      }

      if (newMax !== this._initialMax) {
        this._maxInput.value = Math.floor(this._rangeElem.noUiSlider.get()[1])
        this._maxInput.dispatchEvent(new Event('change'))
        this._maxInput.dispatchEvent(new CustomEvent('update-filter'))
      }

      for (let event of this._options.eventsOnUpdate) {
        let elem = document.querySelector(this._options.formParent)
        elem.dispatchEvent(new Event(event))
      }
    })
  }
}

export default RangeSlider
